import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ISalaryPerMonthFormMeta {

    //   Salary per month
    grossPay: FormInputMeta;
    netPay: FormInputMeta;
    
}

const salaryPerMonthFormMeta = {} as ISalaryPerMonthFormMeta;

salaryPerMonthFormMeta.grossPay = {
    name: "grossPay",
    type: "number",
    label: "Brut",
    placeholder: "",
    validation: yup.number()
};
  
salaryPerMonthFormMeta.netPay = {
    name: "netPay",
    type: "number",
    label: "Net",
    placeholder: "",
    validation: yup.number(),
};

export default salaryPerMonthFormMeta;